import { useState, useEffect } from 'react';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { dataGridPremiumColumns } from '../../utils/helper';
import operationService from '../../service/operation.service';
import useParam from '../../context/ParamContext';
import useConfig from '../../context/ConfigContext';

export default function OperationReports({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSeletion,
  autoCompleteOptions,
}) {
  const { params } = useParam();
  const { config } = useConfig();
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSeletion;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'operationName', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    operationService.getOperationsReport(gridState).then((data) => {
      setReports(data);
      setRefetchTable(false);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'code',
      type: 'string',
      headerName: 'Művelet kódja',
    },
    {
      field: 'operationName',
      type: 'string',
      headerName: 'Művelet',
    },
    {
      field: 'resourceOneId',
      headerName: 'Gép',
      type: 'singleSelect',
      renderCell: (data) => {
        return data.row.resourceOne?.name;
      },
      valueOptions: autoCompleteOptions.resourceOne,
    },
    {
      field: 'companyLocationId',
      headerName: 'Telephely',
      type: 'singleSelect',
      renderCell: (data) => {
        return data.row.companyLocation?.name;
      },
      valueOptions: autoCompleteOptions.companyLocation,
    },
    ...(params.OPERATION_MULTI_MAN_FIELD === 'Y'
      ? [
          {
            field: 'multiManOperation',
            headerName: 'Többemberes művelet',
            type: 'number',
          },
        ]
      : []),
    {
      field: 'costPerHour',
      headerName: 'Költség /óra',
      type: 'number',
    },
    ...(params.OPERATION_GROUP_REPORTING_FIELD === 'Y'
      ? [
          {
            field: 'groupReporting',
            headerName: 'Csoportos lejelentés',
            type: 'boolean',
          },
        ]
      : []),
    ...(params.OPERATION_VERIFICATION_FIELD === 'Y'
      ? [
          {
            field: 'verificationRequired',
            headerName: 'Ellenőrzés szükséges',
            type: 'boolean',
          },
        ]
      : []),
    {
      field: 'showMaterialItemCode',
      headerName: 'Alapanyag cikkszám megjelenítése',
      type: 'boolean',
    },
    {
      field: 'showDoseNumber',
      headerName: 'Adagszám megadása',
      type: 'boolean',
    },
    {
      field: 'useMobileIncoming',
      headerName: 'Mobil (bevételezés)',
      type: 'boolean',
      valueGetter: (_value, row) => {
        return row?.useMobileIncoming ?? false;
      },
    },
    {
      field: 'useMobileOutGoing',
      headerName: 'Mobil (kiadás)',
      type: 'boolean',
      valueGetter: (_value, row) => {
        return row?.useMobileOutGoing ?? false;
      },
    },
    {
      field: 'mobilTargetStatus',
      headerName: 'Mobil cél státusz',
      type: 'singleSelect',
      valueOptions: autoCompleteOptions.prodStatus,
      renderCell: (data) => {
        const code = data.row?.mobilTargetStatus;
        const opt = (autoCompleteOptions?.prodStatus ?? []).find((o) => o?.value === code);
        return opt?.label ?? code ?? '';
      },
    },
    ...(config.operationSequence
      ? [
          {
            field: 'ignoreSequence',
            headerName: 'Sorrendiség figyelmen kívül hagyása',
            type: 'boolean',
          },
        ]
      : []),
    {
      field: 'resourceOneGroupId',
      headerName: 'Gépcsoport',
      type: 'singleSelect',
      renderCell: (data) => {
        return data.row.resourceOneGroup?.name;
      },
      valueOptions: autoCompleteOptions.resourceOneGroup,
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.OperationReports}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={columns}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
}
